<template>
  <div class="mt-12">
    <div class="card bg-white rounded-xl p-4">

      <!-- Header -->
      <div class="relative">
        <div
          class="top_primary_card  bg-primary font-bold text-white p-4 rounded-xl absolute -top-11 w-full"
        >
          Organization list
        </div>
      </div>


      <!-- Organization List -->
      <div class="mt-6">
        <span class="ml-3 heading-5">Organization Name</span>
        <div
          v-if="orgList.length > 0"
          style="overflow-y:auto; white-space:nowrap"
        >
          <div
            v-for="(data, index) in orgList"
            :key="index"
            class="m-2 border-b border-gray-200 bg-white text-sm px-3 py-3 hover:bg-gray-100 cursor-pointer rounded"
            @click="onOrgClick(data)"
          >
            <div class="flex items-center justify-between">
              <p class="text-black font-bold">
                {{ data.organizationName }}
              </p>
            </div>
          </div>
        </div>

        <!-- No Records -->
        <div v-else class="text-center py-6 text-black">
          No records found.
        </div>
      </div>
    </div>

    <!-- Switch Organization Dialog -->
    <userSwitchPermissionDialog
      v-if="showSwitchDialog"
      :orgData="selectedOrg"
      @close="showSwitchDialog = false"
    />

  </div>
</template>

<script>
import MyJobApp from '@/api/MyJobApp.js'
import userSwitchPermissionDialog from './userSwitchPermissionDialog.vue'

export default {
  name: "organizationList",
  components: { userSwitchPermissionDialog },
  data() {
    return {
      orgList: [],
      showSwitchDialog: false,
      selectedOrg: null
    };
  },
  mounted() {
    this.getOrgList()
  },
  methods: {
    onOrgClick (data) {
      this.selectedOrg = data
      this.showSwitchDialog = true
    },
    getOrgList () {
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      MyJobApp.GetOrganizationList(
          response => {
            this.orgList = response.Data.tableRow !== null ? response.Data.tableRow : []
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          },
          (error) => {
          this.$store.dispatch("SetLoader", { status: false, message: "" });
          this.$store.dispatch("SetAlert", {
            showAlert: true,
            message: error.message,
            color: "error",
          });
        }
        )
    },
  }
}  
</script>

<style scoped>
.card {
  box-shadow: 0px 3px 10px rgba(0,0,0,0.1);
}
</style>